// extracted by mini-css-extract-plugin
module.exports = {"item":"PostListItem_item__y_uwk","link":"PostListItem_link__3xHX5"};